import { useContext } from 'react';
import { CurrentUrlContext } from '@immediate_media/component-config';

var useCurrentUrl = function useCurrentUrl() {
  return useContext(CurrentUrlContext);
};

export default useCurrentUrl;